import { ICellRendererParams, ValueGetterParams } from 'ag-grid-community';

export const ArStatusCell = (params: ICellRendererParams) => {
    if (params.data.centerHasOutstandingDelinquency == null) {
        return '';
    }

    if (params.data.centerHasOutstandingDelinquency) {
        return <span className='label label-danger' title='Has outstanding balances > 60 days'>Delinq&apos;t</span>;
    }

    if (params.data.centerHasLatePaymentsInLastYear) {
        return <span className='label label-warning' title='Has had late payments in last year'>Late</span>;
    }

    return <span className='label label-success' title='No late payments in last year'>On-Time</span>;
};

export const arStatusValueGetter = (params: ValueGetterParams) => {
    if (params.data.centerHasOutstandingDelinquency == null) {
        return '';
    }

    if (params.data.centerHasOutstandingDelinquency) {
        return 2;
    }

    if (params.data.centerHasLatePaymentsInLastYear) {
        return 1;
    }

    return 0;
};
